import React from "react";
import UnderOverTableMobile from "./UnderOverTableMobile";
import OddEvenTableMobile from "./OddEvenTableMobile";
import "./RouletteHistoryMobile.scss";

const HistoryMobile = (props) => {
    const {
        statistic: { underOverItems = [], numberItems = [] } = {},
        t,
    } = props;

    return (
        <div className="rhm-history">
            <div className="rhm-history__section">
                <UnderOverTableMobile underOverItems={underOverItems} t={t} />
            </div>

            <div className="rhm-history__section">
                <OddEvenTableMobile numberItems={numberItems} t={t} />
            </div>
        </div>
    );
};

export default HistoryMobile;